import React from "react";

// Functions
import { isEmpty } from 'lodash';
import { sanitize } from "§/src/utils/functions";

// Internals
import './_style.scss';

// Assets
import PlusIcon from '§/src/images/svg/plus.svg';

// Language
import { useTranslation } from 'react-i18next';

const CadenasProduct = React.lazy(() =>
  import("§/src/components/sections/cadenas-product")
)

const AccordionProduct = ( props ) => {

  const { t } = useTranslation();

	// set component class
  const compClassName = 'accordion accordion-flush';
  var compClass = props.className != undefined ? compClassName + ' ' + props.className : compClassName;

	const compId = 'accordion-' + Math.floor(Math.random() * 9999);

  const cadenas = props.cadenas;
  const increment = cadenas ? 2 : 1;

	return (

		<div comp="accordion" className={compClassName} id={compId}>

			<div className="accordion-item" key="1">
				<h2 className="accordion-header h5" id={ 'flush-heading-1' }>
					<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={ '#flush-collapse-1' } aria-expanded="false" aria-controls={ 'flush-collapse-1' }>
						<span className="order">01</span>
						<span className="title">{t('Descrizione')}</span>
						<i className="rounded-circle"><PlusIcon></PlusIcon></i>
					</button>
				</h2>
				<div id={ 'flush-collapse-1' } className="accordion-collapse collapse" aria-labelledby={ 'flush-heading-1' } data-bs-parent={'#' + compId}>
					<div className="accordion-body row">
            <div className="accordion-content col-md-12 offset-lg-4 col-lg-7 col-xl-5" dangerouslySetInnerHTML={{__html: sanitize( props.descriptionTab )}}></div>
					</div>
				</div>
			</div>

      { ! isEmpty( cadenas ) && (
        <div className="accordion-item adv3d-product" key="2" id="cad-cae">
          <h2 className="accordion-header h5" id={ 'flush-heading-2' }>
            <button className="accordion-button" aria-selected="true" type="button" data-bs-toggle="collapse" data-bs-target={ '#flush-collapse-2' } aria-expanded="true" aria-controls={ 'flush-collapse-2' }>
              <span className="order">02</span>
              <span className="title">{t('Visualizza 3D - Scarica modelli CAD/CAE')}</span>
              <i className="rounded-circle"><PlusIcon></PlusIcon></i>
            </button>
          </h2>
          <div id={ 'flush-collapse-2' } className="accordion-collapse collapse show" aria-labelledby={ 'flush-heading-2' } data-bs-parent={'#' + compId}>
            <div className="accordion-body">

                <CadenasProduct
                  data={{
                    cadenasFrame: cadenas,
                  }}
                />

            </div>
          </div>
        </div>
      )}

			{ ! isEmpty( props.data ) && props.data.map(
				( accordionItem, accordionIndex ) => {
					accordionIndex++;

					return(

						<div className="accordion-item" key={accordionIndex+increment}>
					    <h2 className="accordion-header h5" id={ 'flush-heading-' + accordionIndex+increment}>
					      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={ '#flush-collapse-' + accordionIndex+increment} aria-expanded="false" aria-controls={ 'flush-collapse-' + accordionIndex+increment}>
									<span className="order">0{accordionIndex+increment}</span>
									<span className="title">{accordionItem.title}</span>
									<i className="rounded-circle"><PlusIcon></PlusIcon></i>
					      </button>
					    </h2>
					    <div id={ 'flush-collapse-' + accordionIndex+increment} className="accordion-collapse collapse" aria-labelledby={ 'flush-heading-' + accordionIndex+increment} data-bs-parent={'#' + compId}>
                <div className="accordion-body row">
                  <div className="accordion-content col-md-12 offset-lg-4 col-lg-7 col-xl-5" dangerouslySetInnerHTML={{__html: sanitize( props.descriptionTab )}}></div>
      					</div>
					    </div>
					  </div>

					)
				}
			) }

		</div>

	);

};

export default AccordionProduct;
